import React, { Component } from 'react';
import PageTitle from '../../components/PageTitle';
import TableActionBar from '../../components/TableActionBar/index';
import { EditOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { Table, Modal } from 'antd';
import { connect } from 'react-redux';
import qs from 'qs';
import _ from 'lodash';
import { checkPermission } from '../../utils/permission';
import { cleanObject, isValidDate } from '../../utils/helpers';

import { getAllCardType, removeCardType, getOneCardType } from '../../redux/actions/CardTypeActions';
import CardTypeForm from './CardTypeForm';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/card-type',
        breadcrumbName: 'Loại thẻ',
    }
]

class CardTypeList extends Component {

    constructor() {
        super();
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isOpenForm: false,
            currentItem: null
        }
    }

    componentDidMount() {
        this.loadData();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getAllCardType(query).then(() => {
                this.setState({ isLoading: false });
            })
        }
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys })
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        })
    }

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({
            isOpenForm: isOpenForm,
            currentItem: currentItem
        });
    }

    onEdit(id) {
        this.props.getOneCardType(id).then((res) => {
            this.toggleOpenForm(true, res)
        })
    }

    onRemove() {
        this.props.removeCardType(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: [],
            })
            setTimeout(() => {
                Modal.destroyAll();
            }, 800)
        })
    }

    loadData() {
        this.setState({
            isLoading: true
        });
        this.props.getAllCardType().then(() => {
            this.setState({
                isLoading: false
            })
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        })
    }

    render() {
        var {
            selectedRowKeys,
            isLoading,
            isOpenForm,
            currentItem
        } = this.state;
        const { card_type_list, pagination } = this.props;
        var query = qs.parse(this.props.location.search.slice(1));
        var hasSelected = selectedRowKeys.length > 0;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                width: '50px'
            },
            {
                title: 'Tên',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                width: '100px',
                render: (text, record) => {
                    if (text == 1) return <CheckCircleTwoTone twoToneColor="#52c41a" />;
                    if (text == 0) return <CloseCircleTwoTone twoToneColor="#e74c3c" />;
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                sorter: true,
                width: '150px',
                render: (text, record) => {
                    return (<div>{isValidDate(text)}</div>)
                }
            },
            {
                title: 'Người tạo',
                width: '150px',
                dataIndex: 'created_username',
                key: 'created_username'
            },
        ];
        if (checkPermission('card_type', 'update')) {
            columns.push({
                title: 'Actions',
                align: 'center',
                width: '80px',
                render: (text, record) => (
                    <EditOutlined onClick={() => this.onEdit(record.id)} />
                )
            })
        }

        return (
            <div>
                <PageTitle routes={routes} title="Loại thẻ" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('card_type', 'create')}
                        isShowDeleteButton={checkPermission('card_type', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        disabled={!selectedRowKeys.length ? true : false}
                        onDelete={() => this.onRemove()}
                        showSearch={true}
                        showFilter={false}
                        activeFilter={query.status}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi </span> : ''
                        }
                    </TableActionBar>
                </div>

                <Table
                    rowKey='id'
                    size='small'
                    tableLayout="auto"
                    columns={columns}
                    rowSelection={rowSelection}
                    loading={isLoading}
                    dataSource={card_type_list || []}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`
                    }}
                    onChange={(pagination, filter, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
                <CardTypeForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    onCancel={() => this.toggleOpenForm(false)}
                    reloadData={() => this.loadData()}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        card_type_list: state.CardTypeReducer.card_type_list,
        pagination: state.CardTypeReducer.pagination,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllCardType: filter => dispatch(getAllCardType(filter)),
        getOneCardType: id => dispatch(getOneCardType(id)),
        removeCardType: ids => dispatch(removeCardType(ids))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(CardTypeList);
